import { render, staticRenderFns } from "./previewforum.component.vue?vue&type=template&id=0d5208da&scoped=true"
import script from "./previewforum.component.vue?vue&type=script&lang=js"
export * from "./previewforum.component.vue?vue&type=script&lang=js"
import style0 from "./previewforum.component.vue?vue&type=style&index=0&id=0d5208da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5208da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VImg,VRow})
